module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('bg-video'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('logo'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48a78ccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 38
// module chunks = 0